import React from 'react';
import './Style.css';
const Index = () => {
    return (
        <div
            style={{
                overflowY: 'hidden',
                overflowX: 'auto',

                boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
                marginTop: '1.5rem',
                borderRadius: '10px',
            }}
        >
            <table className="remittance_table">
                <thead className="remittance_table_head">
                    <tr className="remittance_table_head_row">
                        <td className="remittance_table_head_data">Remittance ID#</td>
                        <td className="remittance_table_head_data">COD Amount</td>
                        <td className="remittance_table_head_data">Status</td>
                        <td className="remittance_table_head_data">Payment Date</td>

                        {/* <td className="remittance_table_head_data">Freight Deduction</td> */}

                        <td className="remittance_table_head_data">Remittance Amount</td>

                        <td className="remittance_table_head_data">Payment Ref.#</td>

                        <td className="remittance_table_head_data">Download</td>
                    </tr>
                </thead>
                <tbody className="remittance_table_body">
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />{' '}
                    <Component
                        id="46207"
                        codamnt="Rs. 659"
                        status="Paid"
                        date="May 18, 2021"
                        deduction="Rs. 0"
                        remittanceamt="Rs. 659"
                        paymentref="CMS-2105800157V"
                    />
                </tbody>
            </table>
        </div>
    );
};

const Component = ({ id, codamnt, status, date, deduction, remittanceamt, paymentref }) => {
    return (
        <tr className="remittance_table_body_row">
            <td className="remittance_table_body_data">{id}</td>
            <td className="remittance_table_body_data">{codamnt}</td>
            <td className="remittance_table_body_data">{status}</td>
            <td className="remittance_table_body_data">{date}</td>
            {/* <td className="remittance_table_body_data">{deduction}</td> */}
            <td className="remittance_table_body_data">{remittanceamt}</td>

            <td className="remittance_table_body_data">{paymentref}</td>
            <td className="remittance_table_body_data">
                <p className="remittance_table_body_data_download">Download</p>
            </td>
        </tr>
    );
};
export default Index;
